import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import rightArrow from "assets/images/productCard/rightArrow.svg";

import "./productCard.scss";
import { useSlideIndex } from "hooks/useSlider";

const ProductCard = () => {
  const { setSlideIndex } = useSlideIndex();
  const swiperRef = useRef(null);
  const [selectedColor, setSelectedColor] = React.useState("black");

  const handleSelectedColor = (color) => {
    setSelectedColor(color);
    swiperRef.current.slideTo(slides.findIndex((slide) => slide.id === color));
    setSlideIndex(color);
  };

  const slides = [
    { id: "black", url: "/images/productCard/black.gif" },
    { id: "silver", url: "/images/productCard/silver.gif" },
    { id: "gunmetal", url: "/images/productCard/gunmetal.gif" },
    { id: "copper", url: "/images/productCard/copper.gif" }
  ];

  const SilverSelected = () => {
    return (
      <svg
        width="23"
        height="22"
        viewBox="0 0 23 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11Z"
          fill="url(#paint0_linear_3426_3182)"
        />
        <path
          d="M5 11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11Z"
          fill="url(#paint1_linear_3426_3182)"
          style={{ mixBlendMode: "overlay" }}
        />
        <path
          d="M5 11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11C19 14.866 15.866 18 12 18C8.13401 18 5 14.866 5 11Z"
          fill="#BABABA"
          style={{ mixBlendMode: "color" }}
        />
        <rect
          x="1.97119"
          y="1.06543"
          width="19.6429"
          height="19.6429"
          rx="9.82143"
          stroke="#C3C3C5"
          strokeWidth="1.96429"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3426_3182"
            x1="5.77621"
            y1="12.7561"
            x2="18.833"
            y2="9.69754"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#AEB3B4" />
            <stop offset="0.172016" stopColor="#C7C7C7" />
            <stop offset="0.45741" stopColor="#BDC0BF" />
            <stop offset="0.553567" stopColor="#A9AAAA" />
            <stop offset="0.823421" stopColor="#99A3A6" />
            <stop offset="0.925155" stopColor="#B2BABC" />
            <stop offset="1" stopColor="#C1C3C3" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3426_3182"
            x1="10.5887"
            y1="11"
            x2="7.79632"
            y2="3.71263"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    );
  };

  const GunmetalSelected = () => {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.8811 10.9668C3.8811 7.1008 7.01511 3.9668 10.8811 3.9668C14.7471 3.9668 17.8811 7.1008 17.8811 10.9668C17.8811 14.8328 14.7471 17.9668 10.8811 17.9668C7.01511 17.9668 3.8811 14.8328 3.8811 10.9668Z"
          fill="url(#paint0_linear_3426_3146)"
        />
        <path
          d="M3.8811 10.9668C3.8811 7.1008 7.01511 3.9668 10.8811 3.9668C14.7471 3.9668 17.8811 7.1008 17.8811 10.9668C17.8811 14.8328 14.7471 17.9668 10.8811 17.9668C7.01511 17.9668 3.8811 14.8328 3.8811 10.9668Z"
          fill="url(#paint1_linear_3426_3146)"
          style={{ mixBlendMode: "overlay" }}
        />
        <path
          d="M3.8811 10.9668C3.8811 7.1008 7.01511 3.9668 10.8811 3.9668C14.7471 3.9668 17.8811 7.1008 17.8811 10.9668C17.8811 14.8328 14.7471 17.9668 10.8811 17.9668C7.01511 17.9668 3.8811 14.8328 3.8811 10.9668Z"
          fill="#515655"
          style={{ mixBlendMode: "color" }}
        />
        <rect
          x="1.11914"
          y="1.06641"
          width="19.6429"
          height="19.6429"
          rx="9.82143"
          stroke="#778075"
          strokeWidth="1.96429"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3426_3146"
            x1="4.65731"
            y1="12.7229"
            x2="17.7141"
            y2="9.66434"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#576265" />
            <stop offset="0.172016" stopColor="#9EA1A1" />
            <stop offset="0.45741" stopColor="#848B8A" />
            <stop offset="0.553567" stopColor="#576265" />
            <stop offset="0.823421" stopColor="#576265" />
            <stop offset="0.925155" stopColor="#757A7B" />
            <stop offset="1" stopColor="#576265" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3426_3146"
            x1="9.46981"
            y1="10.9668"
            x2="6.67742"
            y2="3.67943"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    );
  };

  const CopperSelected = () => {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.95459 11C3.95459 7.13401 7.0886 4 10.9546 4C14.8206 4 17.9546 7.13401 17.9546 11C17.9546 14.866 14.8206 18 10.9546 18C7.0886 18 3.95459 14.866 3.95459 11Z"
          fill="url(#paint0_linear_3426_3162)"
        />
        <path
          d="M3.95459 11C3.95459 7.13401 7.0886 4 10.9546 4C14.8206 4 17.9546 7.13401 17.9546 11C17.9546 14.866 14.8206 18 10.9546 18C7.0886 18 3.95459 14.866 3.95459 11Z"
          fill="url(#paint1_linear_3426_3162)"
          style={{ mixBlendMode: "overlay" }}
        />
        <path
          d="M3.95459 11C3.95459 7.13401 7.0886 4 10.9546 4C14.8206 4 17.9546 7.13401 17.9546 11C17.9546 14.866 14.8206 18 10.9546 18C7.0886 18 3.95459 14.866 3.95459 11Z"
          fill="#8B674D"
          style={{ mixBlendMode: "color" }}
        />
        <rect
          x="1.04517"
          y="1.06543"
          width="19.6429"
          height="19.6429"
          rx="9.82143"
          stroke="#8B674D"
          strokeWidth="1.96429"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3426_3162"
            x1="4.7308"
            y1="12.7561"
            x2="17.7876"
            y2="9.69754"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#576265" />
            <stop offset="0.172016" stopColor="#9EA1A1" />
            <stop offset="0.45741" stopColor="#848B8A" />
            <stop offset="0.553567" stopColor="#576265" />
            <stop offset="0.823421" stopColor="#576265" />
            <stop offset="0.925155" stopColor="#757A7B" />
            <stop offset="1" stopColor="#576265" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3426_3162"
            x1="9.5433"
            y1="11"
            x2="6.75091"
            y2="3.71263"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    );
  };

  const BlackSelected = () => {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="3.61902"
          y="3.68555"
          width="14.4048"
          height="14.4048"
          rx="7.20238"
          fill="black"
        />
        <rect
          x="3.61902"
          y="3.68555"
          width="14.4048"
          height="14.4048"
          rx="7.20238"
          fill="url(#paint0_linear_3365_3039)"
        />
        <rect
          x="1"
          y="1.06641"
          width="19.6429"
          height="19.6429"
          rx="9.82143"
          stroke="black"
          strokeWidth="1.96429"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3365_3039"
            x1="4.41767"
            y1="12.6948"
            x2="17.8519"
            y2="9.54781"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#041A20" />
            <stop offset="0.172016" stopColor="#1B2424" />
            <stop offset="0.45741" stopColor="#2B3432" />
            <stop offset="0.553567" stopColor="#131718" />
            <stop offset="0.823421" stopColor="#141B1D" />
            <stop offset="0.925155" stopColor="#1D2425" />
            <stop offset="1" />
          </linearGradient>
        </defs>
      </svg>
    );
  };

  const Black = () => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => handleSelectedColor("black")}
      >
        <rect width="20.45" height="20.45" rx="10.225" fill="black" />
        <rect
          width="20.45"
          height="20.45"
          rx="10.225"
          fill="url(#paint0_linear_3591_2827)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3591_2827"
            x1="1.13382"
            y1="12.7902"
            x2="20.206"
            y2="8.32248"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#041A20" />
            <stop offset="0.172016" stopColor="#1B2424" />
            <stop offset="0.45741" stopColor="#2B3432" />
            <stop offset="0.553567" stopColor="#131718" />
            <stop offset="0.823421" stopColor="#141B1D" />
            <stop offset="0.925155" stopColor="#1D2425" />
            <stop offset="1" />
          </linearGradient>
        </defs>
      </svg>
    );
  };

  const Silver = () => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => handleSelectedColor("silver")}
      >
        <path
          d="M0 10.2227C0 4.57684 4.57684 0 10.2227 0V0C15.8685 0 20.4453 4.57684 20.4453 10.2227V10.2227C20.4453 15.8685 15.8685 20.4453 10.2227 20.4453V20.4453C4.57684 20.4453 0 15.8685 0 10.2227V10.2227Z"
          fill="url(#paint0_linear_3591_2843)"
        />
        <path
          d="M0 10.2227C0 4.57684 4.57684 0 10.2227 0V0C15.8685 0 20.4453 4.57684 20.4453 10.2227V10.2227C20.4453 15.8685 15.8685 20.4453 10.2227 20.4453V20.4453C4.57684 20.4453 0 15.8685 0 10.2227V10.2227Z"
          fill="url(#paint1_linear_3591_2843)"
          style={{ mixBlendMode: "overlay" }}
        />
        <path
          d="M0 10.2227C0 4.57684 4.57684 0 10.2227 0V0C15.8685 0 20.4453 4.57684 20.4453 10.2227V10.2227C20.4453 15.8685 15.8685 20.4453 10.2227 20.4453V20.4453C4.57684 20.4453 0 15.8685 0 10.2227V10.2227Z"
          fill="#BABABA"
          style={{ mixBlendMode: "color" }}
        />
        <defs>
          <linearGradient
            id="paint0_linear_3591_2843"
            x1="1.13356"
            y1="12.7873"
            x2="20.2014"
            y2="8.32057"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#AEB3B4" />
            <stop offset="0.172016" stopColor="#C7C7C7" />
            <stop offset="0.45741" stopColor="#BDC0BF" />
            <stop offset="0.553567" stopColor="#A9AAAA" />
            <stop offset="0.823421" stopColor="#99A3A6" />
            <stop offset="0.925155" stopColor="#B2BABC" />
            <stop offset="1" stopColor="#C1C3C3" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3591_2843"
            x1="8.16164"
            y1="10.2227"
            x2="4.08368"
            y2="-0.419665"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    );
  };

  const Gunmetal = () => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => handleSelectedColor("gunmetal")}
      >
        <path
          d="M0 10.225C0 4.57789 4.57789 0 10.225 0V0C15.8721 0 20.45 4.57789 20.45 10.225V10.225C20.45 15.8721 15.8721 20.45 10.225 20.45V20.45C4.57789 20.45 0 15.8721 0 10.225V10.225Z"
          fill="url(#paint0_linear_3591_2818)"
        />
        <path
          d="M0 10.225C0 4.57789 4.57789 0 10.225 0V0C15.8721 0 20.45 4.57789 20.45 10.225V10.225C20.45 15.8721 15.8721 20.45 10.225 20.45V20.45C4.57789 20.45 0 15.8721 0 10.225V10.225Z"
          fill="url(#paint1_linear_3591_2818)"
          style={{ mixBlendMode: "overlay" }}
        />
        <path
          d="M0 10.225C0 4.57789 4.57789 0 10.225 0V0C15.8721 0 20.45 4.57789 20.45 10.225V10.225C20.45 15.8721 15.8721 20.45 10.225 20.45V20.45C4.57789 20.45 0 15.8721 0 10.225V10.225Z"
          fill="#515655"
          style={{ mixBlendMode: "color" }}
        />
        <defs>
          <linearGradient
            id="paint0_linear_3591_2818"
            x1="1.13382"
            y1="12.7902"
            x2="20.206"
            y2="8.32248"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#576265" />
            <stop offset="0.172016" stopColor="#9EA1A1" />
            <stop offset="0.45741" stopColor="#848B8A" />
            <stop offset="0.553567" stopColor="#576265" />
            <stop offset="0.823421" stopColor="#576265" />
            <stop offset="0.925155" stopColor="#757A7B" />
            <stop offset="1" stopColor="#576265" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3591_2818"
            x1="8.16351"
            y1="10.225"
            x2="4.08462"
            y2="-0.419761"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    );
  };

  const Copper = () => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => handleSelectedColor("copper")}
      >
        <path
          d="M0 10.2227C0 4.57684 4.57684 0 10.2227 0V0C15.8685 0 20.4453 4.57684 20.4453 10.2227V10.2227C20.4453 15.8685 15.8685 20.4453 10.2227 20.4453V20.4453C4.57684 20.4453 0 15.8685 0 10.2227V10.2227Z"
          fill="url(#paint0_linear_3591_2842)"
        />
        <path
          d="M0 10.2227C0 4.57684 4.57684 0 10.2227 0V0C15.8685 0 20.4453 4.57684 20.4453 10.2227V10.2227C20.4453 15.8685 15.8685 20.4453 10.2227 20.4453V20.4453C4.57684 20.4453 0 15.8685 0 10.2227V10.2227Z"
          fill="url(#paint1_linear_3591_2842)"
          style={{ mixBlendMode: "overlay" }}
        />
        <path
          d="M0 10.2227C0 4.57684 4.57684 0 10.2227 0V0C15.8685 0 20.4453 4.57684 20.4453 10.2227V10.2227C20.4453 15.8685 15.8685 20.4453 10.2227 20.4453V20.4453C4.57684 20.4453 0 15.8685 0 10.2227V10.2227Z"
          fill="#8B674D"
          style={{ mixBlendMode: "color" }}
        />
        <defs>
          <linearGradient
            id="paint0_linear_3591_2842"
            x1="1.13356"
            y1="12.7873"
            x2="20.2014"
            y2="8.32057"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#576265" />
            <stop offset="0.172016" stopColor="#9EA1A1" />
            <stop offset="0.45741" stopColor="#848B8A" />
            <stop offset="0.553567" stopColor="#576265" />
            <stop offset="0.823421" stopColor="#576265" />
            <stop offset="0.925155" stopColor="#757A7B" />
            <stop offset="1" stopColor="#576265" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3591_2842"
            x1="8.16164"
            y1="10.2227"
            x2="4.08368"
            y2="-0.419665"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>
    );
  };

  return (
    <div>
      <div className="productCardContainer">
        <div className="sliderContainer">
          <Swiper
            slidesPerView={1}
            pagination={{ clickable: true }}
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper;
            }}
          >
            {slides.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div
                  className="slideContent"
                  style={{ backgroundColor: slide.isVideo && "black" }}
                >
                  <img
                    style={{
                      width: "100%",
                      background: "#F3F3F3",
                      borderRadius: "20px",
                      objectFit: "contain"
                    }}
                    autoPlay
                    src={slide.url}
                  />
                </div>
              </SwiperSlide>
            ))}
            <div className="custom-swiper-button-prev"></div>
            <div className="custom-swiper-button-next"></div>
          </Swiper>
        </div>

        <div className="productDetail">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              width: "100%",
              minWidth: "220px"
            }}
          >
            {selectedColor === "black" ? <BlackSelected /> : <Black />}
            {selectedColor === "silver" ? <SilverSelected /> : <Silver />}
            {selectedColor === "gunmetal" ? <GunmetalSelected /> : <Gunmetal />}
            {selectedColor === "copper" ? <CopperSelected /> : <Copper />}
          </div>

          <Link to="https://shop.neosapien.xyz" style={{ width: "100%" }}>
            <p>See Product Details</p>
            <img src={rightArrow} alt="" className="rightArrow" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
